"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radiobox = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
function Radiobox(_a) {
    var { children, error, isLoading, isChecked, isDisabled, name } = _a, rest = __rest(_a, ["children", "error", "isLoading", "isChecked", "isDisabled", "name"]);
    return (react_1.default.createElement(react_2.Flex, Object.assign({}, (isChecked && { "data-checked": true }), { "data-disabled": isDisabled, alignItems: "center", bg: isChecked ? "primary.100" : "white", borderRadius: "8px", borderColor: error ? "danger.600" : "lightgray.500", borderWidth: "1px", cursor: "pointer", minH: "tall", justifyContent: "center", padding: "12px 16px", _checked: {
            bg: "primary.100",
            borderColor: "primary.500",
        }, _disabled: {
            bg: "lightgray.300",
            borderColor: "lightgray.600",
            cursor: "not-allowed",
        }, _focus: {
            boxShadow: "outline",
        } }, rest),
        react_1.default.createElement(react_2.chakra.label, Object.assign({}, (isChecked && { "data-checked": true }), { "data-disabled": isDisabled, color: "darkgray.600", cursor: "pointer", paddingRight: "12px", textStyle: "body1", _checked: {
                color: "primary.600",
                fontWeight: "semibold",
            }, _disabled: {
                color: "darkgray.100",
                cursor: "not-allowed",
            } }), children),
        react_1.default.createElement(react_2.Flex, Object.assign({}, (isChecked && { "data-checked": true }), { "data-disabled": isDisabled, alignItems: "center", bg: "transparent", borderColor: "lightgray.600", borderRadius: "50%", borderWidth: "1px", h: "16px", maxH: "16px", minH: "16px", justifyContent: "center", w: "16px", maxW: "16px", minW: "16px", _checked: {
                bg: "primary.500",
                border: "none",
            }, _disabled: { cursor: "not-allowed" } }), isChecked && (react_1.default.createElement(react_2.Box, { bg: "white", borderRadius: "50%", color: "white", fontSize: "12px", h: "6px", w: "6px" })))));
}
exports.Radiobox = Radiobox;
//# sourceMappingURL=Radiobox.js.map